/**
 * Displays target-list "pills" attached to a company.
 * Used on the Company Profile page so agents instantly see which
 * acquisition campaigns the company belongs to.
 */
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Target } from "lucide-react";
import { targetListsApi, priorityMeta } from "../../TargetLists/api";

export default function CompanyTargetListPills({ companyId }) {
  const [lists, setLists] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!companyId) return;
    let alive = true;
    targetListsApi
      .forCompany(companyId)
      .then((r) => alive && setLists(r.data || []))
      .catch(() => alive && setLists([]))
      .finally(() => alive && setLoading(false));
    return () => { alive = false; };
  }, [companyId]);

  if (loading) return null;
  if (!lists.length) return null;

  return (
    <div
      className="mb-3 bg-gradient-to-r from-amber-50 to-orange-50 rounded-xl border border-amber-200 shadow-sm p-3"
      data-testid="company-target-list-pills"
    >
      <div className="flex items-center gap-1.5 text-xs font-semibold text-amber-900 mb-2">
        <Target size={14} />
        Ciljne liste / Kampanje
      </div>
      <div className="flex flex-wrap gap-1.5">
        {lists.map((l) => {
          const pm = priorityMeta(l.priority);
          return (
            <Link
              key={l.id}
              to={`/target-lists/${l.id}`}
              data-testid={`company-target-list-${l.id}`}
              className={`text-[11px] font-medium px-2 py-1 rounded ${pm.color} hover:opacity-80`}
              title={`Lista: ${l.name} (prioritet: ${pm.label})`}
            >
              {l.name}
            </Link>
          );
        })}
      </div>
    </div>
  );
}
